import { apiClient } from '../../../../utilities/apiClient';

// Cursor cache keyed by page index. Same pattern as AnonymousUsers /
// PhoneVerifications / Users. clearCursorCache resets the map on tab
// unmount so navigating away + back doesn't reuse stale page-N cursors.
const cursorByPage = new Map();
export const clearCursorCache = () => cursorByPage.clear();

export const fetchAllPosts = async ({ page, docLimit }) => {
  const cursor = page === 0 ? null : cursorByPage.get(page - 1) ?? null;
  const res = await apiClient.get('/admin/posts', {
    params: { limit: docLimit, ...(cursor ? { cursor } : {}) },
  });
  const items = res.data.items ?? [];
  if (res.data.nextCursor) cursorByPage.set(page, res.data.nextCursor);
  return items;
};

export const onUpdatePost = ({ postId, data }) =>
  apiClient.patch(`/admin/posts/${postId}`, data);
